import React from 'react'
import BackgroundImg from '../../../assets/images/TestmonialBg.png'

const TheFutureIsHereComponent = () => {
  return (
    <section 
      className="text-white py-12 sm:py-14 md:py-16 lg:py-20 relative"
      style={{
        backgroundImage: `url(${BackgroundImg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      {/* Dark overlay for better text readability */}
      <div className="absolute inset-0 bg-black/50"></div>
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-[48px] font-bold mb-4 sm:mb-5 md:mb-6 font-cormorant-garamond">
          The Future is Here, and You're in Control
        </h2>
        <p className="mx-auto text-lg sm:text-xl md:text-2xl lg:text-[28px] mb-6 sm:mb-7 md:mb-8 max-w-xs sm:max-w-md md:max-w-2xl lg:max-w-4xl">
          Lead the way with our hybrid care solution. Sign up now to unlock a powerful combination of in-person and
          virtual care options, empowering you to take charge of your health.
        </p>
      </div>
    </section>
  )
}

export default TheFutureIsHereComponent